module.exports = __webpack_public_path__ + "media/images/homes/MailChimp-3e1ca8cab00aaaa9a4527b901fc39a6c.png";